import React, { Component } from 'react';
import { Card, Col, message, Modal, Row } from 'antd';
import { ProfileForm } from './ProfileForm';
import { MultiFactorForm } from './MultiFactorForm';
import { BillingDetailsForm } from './BillingDetailsForm';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class SettingsView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true
        };
    }

    async componentDidMount() {
        this.props.store.userStore.getEnrollments();
        this.props.store.billingStore.getBillingCountries();
    }

    async updateProfile(data) {
        if (!this.props.store.userStore.currentUser.use_mfa && data.use_mfa) {
            Modal.success({
                title: 'Complete MFA Setup',
                content: `Log back in to register a device for MFA`,
                onOk: () => {
                    this.props.store.userStore.logout();
                }
            });
        }

        if (this.props.store.userStore.currentUser.use_mfa && !data.use_mfa) {
            //remove device
            const [e1] = this.props.store.userStore.enrollments;
            if (e1) this.props.store.userStore.deleteEnrollments(e1);
        }

        await this.props.store.userStore.updateProfile(data);
        message.success('Profile updated');
    }

    render() {
        return (
            <Row gutter={24}>
                <Col md={{ span: 14, offset: 5 }}>
                    <Card bordered={false} title="My Profile" style={{ margin: 15 }} size={'small'}>
                        <ProfileForm
                            data={this.props.store.userStore.currentUser}
                            onSubmit={this.updateProfile.bind(this)}
                        />
                    </Card>

                    <Card
                        bordered={false}
                        title="Billing Details"
                        style={{ margin: 15 }}
                        size={'small'}
                    >
                        <BillingDetailsForm
                            data={this.props.store.userStore.currentUser}
                            onSubmit={this.updateProfile.bind(this)}
                        />
                    </Card>

                    <Card
                        bordered={false}
                        title="Multi Factor Authentication"
                        style={{ margin: 15 }}
                        size={'small'}
                    >
                        <MultiFactorForm
                            data={this.props.store.userStore.currentUser}
                            enrollments={this.props.store.userStore.enrollments}
                            onSubmit={this.updateProfile.bind(this)}
                        />
                    </Card>
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Settings/index.js